<template>
  <v-container fluid>
    <v-expansion-panel v-model="filterPanel" expand>
      <v-expansion-panel-content key="filterPanel">
        <template v-slot:header>
          <div>Server Side Filters</div>
        </template>
        <v-card>
          <v-card-text>
            <v-container grid-list-xl fluid>
              <v-layout row wrap>
                <v-flex xs12 sm6 md12>
                  <v-select
                    label="Filter by Status"
                    multiple
                    :items="Statuses"
                    item-value="value"
                    item-text="text"
                    v-model="statusFilter"
                    clearable
                    single-line
                    hide-details
                    deletable-chips
                    chips
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-autocomplete
                    label="Filter by Supplier"
                    :items="suppliers"
                    item-value="key"
                    item-text="name"
                    v-model="supplierFilter"
                    clearable
                    single-line
                    hide-details
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-autocomplete
                    label="Filter by Engineer"
                    :items="supplierFilterEngineers"
                    item-value="key"
                    item-text="name"
                    v-model="engineerFilter"
                    clearable
                    single-line
                    hide-details
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-autocomplete
                    label="Filter by Chargeable"
                    :items="['Yes', 'No']"
                    v-model="chargeableFilter"
                    clearable
                    single-line
                    hide-details
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-card>
                    <v-card-text>
                      <v-radio-group v-model="dateFilterType" row>
                        <v-radio label="None" value="none"></v-radio>
                        <v-radio label="Created" value="created"></v-radio>
                        <v-radio label="Scheduled" value="scheduled"></v-radio>
                        <v-radio label="Completed" value="completed"></v-radio>
                      </v-radio-group>
                      <v-menu
                        v-model="startFilterMenu"
                        :close-on-content-click="false"
                        full-width
                        max-width="290"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="formattedStartFilter"
                            label="From Date"
                            readonly
                            :disabled="dateFilterType === 'none'"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="startFilter"
                          @change="startFilterMenu = false"
                        ></v-date-picker>
                      </v-menu>
                      <v-menu
                        v-model="endFilterMenu"
                        :close-on-content-click="false"
                        full-width
                        max-width="290"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="formattedEndFilter"
                            label="To Date"
                            readonly
                            :disabled="dateFilterType === 'none'"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="endFilter"
                          @change="endFilterMenu = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 class="text-xs-center">
                  <v-btn color="primary" @click="fetchData">Load Jobs</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <h1 v-if="!filteredJobs.length && initialFetch" class="text-xs-center">
      No jobs meet your criteria
    </h1>
    <v-layout wrap v-if="filteredJobs.length">
      <v-flex v-for="(card, i) in summaryCards" :key="i">
        <v-card class="pa-2 mt-1 text-xs-center">
          <v-progress-circular
            :size="70"
            :width="10"
            :rotate="360"
            :value="(states[i] / totalJobs) * 100"
            :color="card.color"
          >
            {{ states[i] }}
          </v-progress-circular>
          <div class="title">{{ card.title }}</div>
        </v-card>
      </v-flex>
    </v-layout>
    <v-card class="mt-2" v-if="filteredJobs.length">
      <!-- <v-btn @click="exportTemplates">Export Templates</v-btn>
      <v-btn @click="exportJobs">Export Jobs</v-btn> -->
      <!-- <v-btn @click="processJobs">Process Jobs</v-btn> -->
      <v-card-title>
        <v-switch
          v-model="showFinanceColumns"
          label="Show Finance Columns"
        ></v-switch>
        <v-text-field
          append-icon="search"
          label="Search"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn @click="exportJobs" color="primary">Export</v-btn>
        <bulk-update-jobs-dialog
          @updateComplete="getJobs"
        ></bulk-update-jobs-dialog>
      </v-card-title>
      <v-data-table
        :rows-per-page-items="[
          25,
          50,
          100,
          { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
        ]"
        :headers="filteredHeaders"
        :items="filteredJobs"
        :search="search"
        v-model="selected"
        item-key="id"
        select-all
        :loading="tableLoading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td>
              <v-checkbox
                primary
                hide-details
                v-model="props.selected"
              ></v-checkbox>
            </td>
            <td @click.stop="props.expanded = !props.expanded">
              {{ props.item.customerName }}
            </td>
            <td>
              <v-edit-dialog
                :return-value.sync="updateRegV"
                lazy
                large
                persistent
                @save="updateReg(props.item)"
              >
                <div>
                  <v-btn small icon><v-icon>mdi-pencil</v-icon></v-btn>
                  {{
                    props.item.Vehicle
                      ? props.item.Vehicle
                        ? vehicleRegFromID(props.item.Vehicle)
                        : props.item.VehicleReg
                      : props.item.vehReg
                  }}
                </div>
                <template v-slot:input>
                  <v-text-field
                    :value="
                      props.item.Vehicle
                        ? props.item.Vehicle
                          ? vehicleRegFromID(props.item.Vehicle)
                          : props.item.VehicleReg
                        : props.item.vehReg
                    "
                    @change="(v) => (updateRegV = v)"
                  />
                </template>
              </v-edit-dialog>
            </td>
            <td @click.stop="props.expanded = !props.expanded">
              {{ props.item.CreatedDate | formatDate }}
            </td>
            <td @click.stop="props.expanded = !props.expanded">
              {{ props.item.Date | formatDate }}
            </td>
            <td @click.stop="props.expanded = !props.expanded">
              {{ props.item.CompletedDate | formatDate }}
            </td>
            <td @click.stop="props.expanded = !props.expanded">
              {{ props.item.AllocatedEngineer }}
            </td>
            <td @click.stop="props.expanded = !props.expanded">
              {{ props.item.Project }}
            </td>
            <td @click.stop="props.expanded = !props.expanded">
              {{ props.item.JobNo }}
            </td>
            <td @click.stop="props.expanded = !props.expanded">
              {{ props.item.Status | jobStatus(props.item.Allocated) }}
            </td>
            <td
              v-if="showFinanceColumns"
              @click.stop="props.expanded = !props.expanded"
            >
              £{{ props.item.customerPrice }}
            </td>
            <td
              v-if="showFinanceColumns"
              @click.stop="props.expanded = !props.expanded"
            >
              £{{ props.item.engineerCost }}
            </td>
            <td
              v-if="showFinanceColumns"
              @click.stop="props.expanded = !props.expanded"
            >
              £{{ props.item.hardwareCost }}
            </td>
            <td
              v-if="showFinanceColumns"
              @click.stop="props.expanded = !props.expanded"
            >
              {{ props.item.invoiced }}
            </td>
            <td class="text-xs-right">
              <v-tooltip
                v-if="props.item.jobStarted && props.item.Status == 0"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon class="mx-0">
                    <v-icon color="blue">account_box</v-icon>
                  </v-btn>
                </template>
                <span
                  >Engineer has started this job but not sent it back to portal
                  yet</span
                >
              </v-tooltip>
              <v-tooltip v-if="props.item.Status > 0" bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    v-if="props.item.Status > 0"
                    icon
                    class="mx-0"
                    @click.stop="viewJob(props.item.id)"
                  >
                    <v-icon v-if="props.item.Status > 2" color="primary"
                      >assignment_turned_in</v-icon
                    >
                    <v-icon v-else-if="props.item.Status == 2" color="success"
                      >assignment_ind</v-icon
                    >
                    <v-icon v-else color="red">assignment_late</v-icon>
                  </v-btn>
                </template>
                <span v-if="props.item.Status > 2">Approved</span>
                <span v-else-if="props.item.Status == 2">Completed</span>
                <span v-else>Issue</span>
              </v-tooltip>
              <v-tooltip v-if="props.item.chargeable" bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    v-if="props.item.chargeable"
                    icon
                    class="mx-0"
                  >
                    <v-icon color="black">mdi-currency-gbp</v-icon>
                  </v-btn>
                </template>
                <span>Chargeable</span>
              </v-tooltip>
              <v-tooltip v-if="props.item.Status < 3" bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    v-if="props.item.Status < 3"
                    icon
                    class="mx-0"
                    @click.stop="approveJob(props.item.id)"
                  >
                    <v-icon color="green">check</v-icon>
                  </v-btn>
                </template>
                <span>Approve Job</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    class="mx-0"
                    @click.stop="editItem(props.item.id)"
                  >
                    <v-icon color="teal">edit</v-icon>
                  </v-btn>
                </template>
                <span>Edit Item</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    class="mx-0"
                    @click.stop="deleteItem(props.item)"
                  >
                    <v-icon color="pink">delete</v-icon>
                  </v-btn>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
          <v-layout justify-center>
            <v-card class="ma-2">
              {{ props.item.notes }}
              <v-list dark dense>
                <v-list-tile
                  v-for="(template, i) in props.item.templates"
                  v-bind:key="i"
                >
                  <v-list-tile-action>
                    <v-checkbox disabled input-value="true"></v-checkbox>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{
                      templates.find((t) => {
                        return t.id === template;
                      }).name
                    }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-layout>
        </template>
      </v-data-table>
    </v-card>
    <completed-view
      :visible.sync="viewDialog"
      :JobID="currentJob"
      @approveJob="approveJob"
      @issueJob="issueJob"
    ></completed-view>

    <v-dialog v-model="dialog" max-width="90%" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-alert type="info" :value="editedItem.Status > 1"
                  >This job has already been completed, please only edit the job
                  if details were incorrect at time of install.</v-alert
                >
                <v-alert type="error" v-model="saveJobFailed" dismissible
                  >An error occured when trying to save the job. Please try
                  again.</v-alert
                >
                <v-form ref="newJob" v-model="newJobValid">
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-textarea
                        label="Notes"
                        outline
                        v-model="editedItem.notes"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-combobox
                        label="Vehicle"
                        :items="vehicles"
                        :loading="gettingVehicles"
                        item-value="VehicleReg"
                        item-text="VehicleReg"
                        v-model="vehicleSelect"
                        :rules="[(v) => !!v || 'Item is required']"
                        required
                        clearable
                      ></v-combobox>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        label="Select Customer"
                        :items="customerList"
                        v-model="editedItem.Customer"
                        item-text="name"
                        item-value="key"
                        dense
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        label="Select Site"
                        :items="sites"
                        v-model="editedItem.Site"
                        item-text="name"
                        item-value="key"
                        hint="What site is this vehicle at?"
                        dense
                        readonly
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        label="Select Products"
                        :items="products"
                        v-model="selectProducts"
                        multiple
                        chips
                        item-text="name"
                        item-value="id"
                        hint="What templates does this job need?"
                        persistent-hint
                        deletable-chips
                        dense
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-autocomplete
                        label="Assign to Supplier"
                        :items="suppliers"
                        v-model="supplierSelect"
                        item-text="name"
                        item-value="key"
                        clearable
                        disabled
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-autocomplete
                        label="Assign to Engineer"
                        :items="supplierSelectEngineers"
                        v-model="editedItem.Allocated"
                        item-text="name"
                        item-value="key"
                        :loading="gettingEngineers"
                        clearable
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        label="Assign to Project"
                        :items="projects"
                        v-model="editedItem.Project"
                        item-text="projectId"
                        item-value="projectId"
                        clearable
                        @change="setJobSupplier"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-menu
                        ref="dateDialog"
                        v-model="dateDialog"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        :nudge-right="40"
                        min-width="290px"
                        :return-value.sync="editedItem.Date"
                        :close-on-content-click="false"
                      >
                        <v-text-field
                          slot="activator"
                          label="Scheduled Date"
                          :value="editedItem.Date | formatDate"
                          prepend-icon="event"
                          readonly
                        ></v-text-field>
                        <v-date-picker
                          v-model="editedItem.Date"
                          scrollable
                          @input="$refs.dateDialog.save(editedItem.Date)"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        label="Chargeable"
                        :items="chargeableOptions"
                        v-model="editedItem.chargeable"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-select
                        label="Finance Type"
                        :items="['Warranty', 'Chargeable', 'Unknown']"
                        v-model="editedItem.finance.type"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field
                        prefix="£"
                        number
                        label="Customer Price"
                        v-model="editedItem.finance.customerCost"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field
                        prefix="£"
                        number
                        label="Engineer Cost"
                        v-model="editedItem.finance.supplierCost"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field
                        prefix="£"
                        number
                        label="Hardware Cost"
                        v-model="editedItem.hardwareCost"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-select
                        label="Job Invoiced"
                        :items="['YES', 'NO', 'N/A']"
                        v-model="editedItem.invoiced"
                      ></v-select>
                    </v-flex>
                    <template v-if="oldExtras">
                      <template v-for="(item, index) in editedItem.extras">
                        <v-flex xs12 sm6 md4 v-if="item.length" :key="index">
                          <v-text-field
                            type="text"
                            :label="index"
                            v-model="editedItem.extras[index]"
                          ></v-text-field>
                        </v-flex>
                      </template>
                    </template>
                    <v-flex v-else xs12 sm6 md4>
                      <v-btn @click="oldExtras = true">Show Old Extras</v-btn>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout
                        wrap
                        v-for="(field, index) in editedItem.additionalFields"
                        :key="index"
                      >
                        <v-flex xs4 md2>
                          <v-text-field
                            label="Field Name"
                            v-model="field['fieldName']"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs7 md4>
                          <v-text-field
                            label="Field Value"
                            v-model="field['fieldValue']"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs1>
                          <v-btn
                            flat
                            icon
                            color="primary"
                            @click="
                              editedItem.additionalFields.splice(index, 1)
                            "
                          >
                            <v-icon>close</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-btn
                      color="primary"
                      @click="addAdditionalField"
                      ref="additionalFieldBtn"
                    >
                      <v-icon left>add</v-icon>Additional Field</v-btn
                    >
                    <v-flex xs12>
                      <template v-for="product in editedItem.templateExtras">
                        <h4 :key="product.id">
                          Product: {{ product.product.name }}
                        </h4>
                        <template
                          v-for="(item, index) in productExtras.filter(
                            (p) => p.id === product.product.id
                          )"
                        >
                          <v-flex
                            xs12
                            sm6
                            md4
                            :key="index"
                            v-if="editedItem.extras[product.product.id]"
                          >
                            <v-select
                              v-if="item.type === 'choice'"
                              :label="item.name"
                              :items="item.options"
                              v-model="
                                editedItem.extras[product.product.id][item.name]
                              "
                              :required="item.required === true"
                              :clearable="item.default === '' ? true : false"
                            ></v-select>
                            <v-text-field
                              type="text"
                              v-else-if="item.type === 'text'"
                              :label="item.name"
                              v-model="
                                editedItem.extras[product.product.id][item.name]
                              "
                              :required="item.required === true"
                            ></v-text-field>
                            <v-text-field
                              type="number"
                              :step="item.step"
                              v-else
                              :label="item.name"
                              v-model="
                                editedItem.extras[product.product.id][item.name]
                              "
                              :required="item.required === true"
                            ></v-text-field>
                          </v-flex>
                        </template>
                        <template
                          class="px-4"
                          v-for="device in product.templateDetails"
                        >
                          <template v-if="device.extras !== undefined">
                            <v-card :key="device.id">
                              <h5>Device: {{ device.name }}</h5>
                              <table
                                style="width: 100%"
                                v-if="device.deviceDetails"
                              >
                                <thead>
                                  <th
                                    :key="detail.id"
                                    v-for="detail in device.extras"
                                  >
                                    {{ detail.name }}
                                  </th>
                                </thead>
                                <tbody>
                                  <td
                                    :key="detail.id"
                                    class="pa-2 text-sm-center"
                                    v-for="detail in device.extras"
                                  >
                                    <span>{{
                                      device.deviceDetails[detail.name]
                                    }}</span>
                                  </td>
                                </tbody>
                              </table>
                              <template v-for="detail in device.extras">
                                <v-autocomplete
                                  class="mx-4 mt-2"
                                  box
                                  label="Select Device"
                                  append-outer-icon="refresh"
                                  :key="detail.name"
                                  v-if="
                                    detail.type === 'uid' &&
                                    !device.deviceDetails
                                  "
                                  @change="
                                    (v) => {
                                      device.deviceDetails = v;
                                    }
                                  "
                                  @click:append-outer="forceUpdate"
                                  item-value="id"
                                  return-object
                                  item-text="id"
                                  :items="
                                    devices.filter(
                                      (d) => d.type === device.id && !d.vehicle
                                    )
                                  "
                                  :value="
                                    device.deviceDetails !== undefined
                                      ? device.deviceDetails[detail.name]
                                      : ''
                                  "
                                />
                              </template>
                            </v-card>
                          </template>
                        </template>
                      </template>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
          <v-btn
            color="green darken-1"
            flat
            @click.native="save"
            :disabled="!newJobValid"
            :loading="savingSaveJob"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Add to project dialog -->
    <v-dialog v-model="addToProjectDialog" max-width="500px" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline mr-4">Assign Jobs to Project</span>
          <a v-if="!createNewProject" @click="createNewProject = true"
            >create new project?</a
          >
          <a v-else @click="createNewProject = false">cancel new project?</a>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-select
              v-if="createNewProject === false"
              label="Assign to Project"
              :items="projects"
              v-model="assignToProject"
              item-text="projectId"
              item-value="projectId"
            ></v-select>
            <template v-if="createNewProject === true">
              <v-select
                label="Project to copy"
                :items="projects"
                v-model="duplicateProjectSource"
                item-text="projectId"
                item-value="projectId"
              ></v-select>
              <v-select
                label="Supplier"
                :items="suppliers"
                v-model="duplicateProjectSupplier"
                item-text="name"
                item-value="key"
              ></v-select>
              <v-btn
                :disabled="duplicateProjectSource === null"
                @click="createDuplicateProject"
                >Create New Project</v-btn
              >
            </template>
            <h3>Jobs to be assigned</h3>
            <v-list dense v-if="selected">
              <v-list-tile v-for="(job, index) in selected" :key="index">
                {{ job.JobNo }}
              </v-list-tile>
            </v-list>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            flat
            @click.native="addJobsToProject"
            :disabled="assignToProject === null"
            :loading="savingAddJobsToProject"
            >Save</v-btn
          >
          <v-btn
            color="blue darken-1"
            right
            flat
            @click.native="addToProjectDialog = false"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Approve job dialog -->
    <v-dialog v-model="issueDialog" max-width="500px" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Flag Issue With Job</span>
        </v-card-title>
        <v-card-text>
          <h4>You are about to flag an issue with job {{ currentJobNo }}.</h4>
          <template
            v-if="
              jobs.find((job) => {
                return job.id === this.currentJob;
              })
            "
          >
            <v-textarea v-model="JobNotes" outline label="Notes"></v-textarea>
          </template>
        </v-card-text>
        <v-card-actions
          v-if="
            jobs.find((job) => {
              return job.id === this.currentJob;
            })
          "
        >
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            flat
            @click.native="issueCurrentJob"
            :loading="issueingJob"
            >Issue With Job</v-btn
          >
          <v-btn
            color="blue darken-1"
            right
            flat
            @click.native="issueDialog = false"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Assign to engineer dialog -->
    <v-dialog v-model="assignToEngineerDialog" max-width="500px" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Assign Jobs to Engineer</span>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-autocomplete
              label="Assign to Supplier"
              :items="suppliers"
              v-model="assignToSupplier"
              item-text="name"
              item-value="key"
              disabled
            ></v-autocomplete>
            <v-autocomplete
              label="Assign to Engineer"
              :items="assignToSupplierEngineers"
              v-model="assignToEngineer"
              item-text="name"
              item-value="key"
              :loading="gettingEngineers"
              clearable
              :disabled="!assignToSupplier"
            ></v-autocomplete>
            <h3>Jobs to be assigned</h3>
            <v-list dense v-if="selected">
              <v-list-tile v-for="(job, index) in selected" :key="index">
                {{ job.JobNo }}
              </v-list-tile>
            </v-list>
            <h5 v-if="!assignToSupplier" class="error--text">
              A Supplier must be assigned to the selected jobs parent project
            </h5>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            flat
            @click.native="assignJobsToEngineer"
            :loading="savingAssignJobsToEngineer"
            :disabled="!assignToSupplier"
            >Save</v-btn
          >
          <v-btn
            color="blue darken-1"
            right
            flat
            @click.native="assignToEngineerDialog = false"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete jobs dialog -->
    <v-dialog v-model="deleteJobsDialog" max-width="500px" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Delete Jobs</span>
        </v-card-title>
        <v-card-text>
          <h3>You are about to delete these jobs</h3>
          <v-list dense v-if="selected">
            <v-list-tile v-for="(job, index) in selected" :key="index">
              {{ job.JobNo }}
            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            flat
            @click.native="deleteMultiJobs"
            :loading="deletingJobs"
            >Delete Jobs</v-btn
          >
          <v-btn
            color="blue darken-1"
            right
            flat
            @click.native="deleteJobsDialog = false"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Approve jobs dialog -->
    <v-dialog v-model="approveJobsDialog" max-width="500px" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Approve Jobs</span>
        </v-card-title>
        <v-card-text>
          <h3>You are about to approve these jobs</h3>
          <v-list dense v-if="selected">
            <v-list-tile v-for="(job, index) in selected" :key="index">
              {{ job.JobNo }}
            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            flat
            @click.native="approveMultiJobs"
            :loading="approvingJobs"
            >Approve Jobs</v-btn
          >
          <v-btn
            color="blue darken-1"
            right
            flat
            @click.native="approveJobsDialog = false"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Approve job dialog -->
    <v-dialog v-model="approveDialog" max-width="500px" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Approve Job</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="approvalReg"
            label="Update Vehicle Reg"
          ></v-text-field>
          <h4>You are about to approve job {{ currentJobNo }}.</h4>
          <template
            v-if="
              jobs.find((job) => {
                return job.id === this.currentJob;
              })
            "
          >
            <h5>Job Attachments</h5>
            <v-list-tile
              v-for="doc in jobs.find((job) => {
                return job.id === this.currentJob;
              }).completedDocs"
              :key="doc.name"
            >
              <v-list-tile-avatar
                ><v-icon>mdi-file-document-outline</v-icon></v-list-tile-avatar
              >
              <v-list-tile-content>
                <v-list-tile-title>
                  <a :href="doc.downloadUrl" target="_BLANK">{{ doc.name }}</a>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
          <upload-btn
            :multiple="true"
            :title="'Attach New Document'"
            :fileChangedCallback="attachCompletedFile"
            ref="btnAttachCompletedFile"
          >
            <template slot="icon">
              <v-icon color="white">mdi-paperclip</v-icon>
            </template>
          </upload-btn>
          <v-progress-linear
            :color="fileProgress === 100 ? 'success' : 'primary'"
            :value="fileProgress"
          ></v-progress-linear>
        </v-card-text>
        <v-card-actions
          v-if="
            jobs.find((job) => {
              return job.id === this.currentJob;
            })
          "
        >
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            flat
            @click.native="approveCurrentJob"
            :loading="approvingJob"
            :disabled="
              jobs.find((job) => {
                return job.id === this.currentJob;
              }).Status < 1 &&
              !jobs.find((job) => {
                return job.id === this.currentJob;
              }).completedDocs
            "
            >Approve Job</v-btn
          >
          <v-btn
            color="blue darken-1"
            right
            flat
            @click.native="approveDialog = false"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-fab-transition>
      <v-speed-dial
        v-model="fab"
        v-show="selected.length > 0"
        bottom
        right
        fixed
      >
        <v-btn slot="activator" color="primary" dark fab hover v-model="fab">
          <v-icon>edit</v-icon>
          <v-icon>close</v-icon>
        </v-btn>
        <v-tooltip
          :disabled="tooltipsDisabled"
          left
          :value="tooltips"
          color="pink"
        >
          <v-btn
            slot="activator"
            fab
            dark
            small
            color="pink"
            @click="deleteJobsDialog = true"
          >
            <v-icon>delete</v-icon>
          </v-btn>
          <span>Delete</span>
        </v-tooltip>
        <v-tooltip
          v-if="selectedSameProject"
          color="indigo"
          :disabled="tooltipsDisabled"
          left
          :value="tooltips"
        >
          <v-btn
            slot="activator"
            fab
            dark
            small
            color="indigo"
            @click="assignToEngineerDialog = true"
          >
            <v-icon>assignment_ind</v-icon>
          </v-btn>
          <span>Assign Engineer</span>
        </v-tooltip>
        <v-tooltip
          :disabled="tooltipsDisabled"
          left
          :value="tooltips"
          color="orange"
        >
          <v-btn
            slot="activator"
            fab
            dark
            small
            color="orange"
            @click="addToProjectDialog = true"
          >
            <v-icon>library_add</v-icon>
          </v-btn>
          <span>Change Project</span>
        </v-tooltip>
        <v-tooltip
          :disabled="tooltipsDisabled"
          left
          :value="tooltips"
          color="green"
        >
          <v-btn
            slot="activator"
            fab
            dark
            small
            color="green"
            @click="approveJobsDialog = true"
          >
            <v-icon>check</v-icon>
          </v-btn>
          <span>Approve Jobs</span>
        </v-tooltip>
        <v-tooltip
          :disabled="tooltipsDisabled"
          left
          :value="tooltips"
          color="yellow"
        >
          <v-btn
            slot="activator"
            fab
            dark
            small
            color="yellow"
            @click="printSelectedJobs"
          >
            <v-icon>print</v-icon>
          </v-btn>
          <span>Print</span>
        </v-tooltip>
      </v-speed-dial>
    </v-fab-transition>
    <v-dialog v-model="tableLoading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Fetching Data
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { sendEmail, updateAuditLog, fireStore, storage } from "../firebase";
import moment from "moment";
import UploadButton from "vuetify-upload-button";
export default {
  components: {
    "upload-btn": UploadButton,
  },
  props: ["customer", "job"],
  data() {
    return {
      showFinanceColumns: false,
      initialFetch: false,
      dateFilterType: "none",
      startFilterMenu: false,
      startFilter: moment().add(-30, "days").format("YYYY-MM-DD"),
      endFilterMenu: false,
      endFilter: moment().add(1, "day").format("YYYY-MM-DD"),
      chargeableFilter: null,
      selected: [],
      saveJobFailed: false,
      fab: false,
      summaryCards: [
        { title: "Not Started", color: "grey" },
        { title: "Awaiting Install", color: "orange" },
        { title: "Issue", color: "red" },
        { title: "Complete", color: "cyan" },
        { title: "Complete - Cubo Approved", color: "green" },
      ],
      filterPanel: ["filterPanel"],
      expanded: false,
      newJobValid: false,
      viewDialog: false,
      // customerList: [],
      oldExtras: false,
      currentJob: "",
      gettingEngineers: false,
      gettingVehicles: false,
      dateDialog: false,
      sites: [],
      fileProgress: 0,
      jobs: [],
      projects: [],
      addToProjectDialog: false,
      pagination: {
        sortBy: "CompletedDate",
        rowsPerPage: 25,
        page: 1,
        descending: true,
      },
      headers: [
        {
          text: "Customer",
          value: "customerName",
          align: "left",
        },
        {
          text: "Vehicle",
          value: "vehReg",
          align: "left",
        },
        {
          text: "Created Date",
          value: "CreatedDate",
          align: "left",
        },
        {
          text: "Scheduled Date",
          value: "Date",
          align: "left",
        },
        {
          text: "Completed Date",
          value: "CompletedDate",
          align: "left",
        },
        {
          text: "Engineer",
          value: "AllocatedEngineer",
          align: "left",
        },
        {
          text: "Project",
          value: "Project",
          align: "left",
        },
        {
          text: "Job Number",
          value: "JobNo",
          align: "left",
        },
        {
          text: "Status",
          value: "Status",
          align: "left",
        },
        {
          text: "Customer Price",
          value: "customerPrice",
          align: "left",
        },
        {
          text: "Engineer Cost",
          value: "engineerCost",
          align: "left",
        },
        {
          text: "Hardware Cost",
          value: "hardwareCost",
          align: "left",
        },
        {
          text: "Job Invoiced",
          value: "invoiced",
          align: "left",
        },
        {
          text: "Actions",
          value: "actions",
          align: "right",
          sortable: false,
        },
      ],
      search: "",
      dialog: false,
      editedIndex: -1,
      engineers: [],
      vehicles: [],
      selectProducts: [],
      editedItem: {
        vehReg: "",
        JobNo: null,
        templates: ["preCheck"],
        productExtras: [],
        Supplier: "",
        Allocated: "",
        Date: null,
        Status: 0,
        additionalFields: [],
        extras: {},
        Project: null,
        notes: "",
        finance: {
          customerCost: "",
          supplierCost: "",
          type: "",
        },
      },
      supplierSelect: "",
      vehicleSelect: "",
      defaultItem: {
        vehReg: "",
        JobNo: null,
        templates: ["preCheck"],
        productExtras: [],
        Supplier: "",
        Allocated: "",
        Date: null,
        Status: 0,
        additionalFields: [],
        extras: {},
        Project: null,
        notes: "",
        finance: {
          type: "",
        },
      },
      tableLoading: false,
      states: [],
      JobNotes: "",
      totalJobs: 0,
      productExtras: [],
      assignToProject: null,
      assignToEngineerDialog: false,
      assignToEngineer: "",
      assignToSupplier: "",
      savingAddJobsToProject: false,
      savingAssignJobsToEngineer: false,
      savingSaveProject: false,
      savingSaveJob: false,
      deleteJobsDialog: false,
      deletingJobs: false,
      approvalReg: "",
      approveJobsDialog: false,
      approvingJobs: false,
      approvingJob: false,
      issueingJob: false,
      issueDialog: false,
      approveDialog: false,
      statusFilter: [5, 4, 1, 2],
      Statuses: [
        { text: "Not Started", value: 5 },
        { text: "Awaiting Install", value: 4 },
        { text: "Issue", value: 1 },
        { text: "Complete", value: 2 },
        { text: "Complete - Cubo Approved", value: 3 },
      ],
      duplicateProjectSource: null,
      duplicateProjectSupplier: null,
      createNewProject: false,
      tooltips: false,
      tooltipsDisabled: false,
      updateRegV: null,
      supplierFilter: null,
      engineerFilter: null,
    };
  },
  created() {
    // fireStore.collection('Customers').get()
    // .then(snap => {
    //   snap.forEach(doc => {
    //     this.customerList.push({key: doc.id, name: doc.data().customerName, shortName: doc.data().shortName})
    //   })
    //   this.customerList.sort(function (a, b) {
    //     const aName = a.name.toLowerCase()
    //     const bName = b.name.toLowerCase()
    //     return aName < bName ? -1 : aName > bName ? 1 : 0
    //   })
    // })
    this.getEngineers();
    this.getSites();
    this.getVehicles();
    this.$store.dispatch("fetchCustomers");
    this.$store.dispatch("fetchSuppliers");
  },
  mounted() {
    if (this.job !== undefined) {
      this.viewJob(this.job);
    }
  },
  computed: {
    chargeableOptions() {
      return [
        { text: "Yes", value: true },
        { text: "No", value: false },
      ];
    },
    filteredHeaders() {
      let headers = JSON.parse(JSON.stringify(this.headers));

      if (this.showFinanceColumns) {
        return headers;
      }

      headers.splice(-5, 4);
      console.log(headers);

      return headers;
    },
    formattedStartFilter() {
      return this.startFilter
        ? moment(this.startFilter).format("DD/MM/YYYY")
        : "";
    },
    formattedEndFilter() {
      return this.endFilter ? moment(this.endFilter).format("DD/MM/YYYY") : "";
    },
    user() {
      return this.$store.getters.userData;
    },
    customerList() {
      return this.$store.getters.customers;
    },
    templates() {
      return this.$store.getters.deviceTypes;
    },
    products() {
      return this.$store.getters.productTypes;
    },
    devices() {
      return this.$store.getters.devices;
    },
    customerManagement() {
      let customerManagement = {};
      for (let customer of this.customerList) {
        customerManagement[customer.key] = {
          BDM: customer.BDM,
          DBAM: customer.DeskManager,
        };
      }
      return customerManagement;
    },
    filteredJobs() {
      let filteredJobs = [];
      for (let job in this.jobs) {
        let i = this.jobs[job];

        // if (this.engineerFilter) {
        //   if (i.Allocated !== this.engineerFilter) {
        //     continue
        //   }
        // }

        // if (this.supplierFilter) {
        //   const project = this.projects.find(p => p.projectId === i.Project)
        //   console.log(project)
        //   if (!project || project.Supplier !== this.supplierFilter) {
        //     continue
        //   }
        // }

        if (this.chargeableFilter === "No" && i.chargeable) {
          continue;
        }

        if (this.statusFilter.indexOf(3) !== -1 && i.Status === 3) {
          filteredJobs.push(i);
        } else if (this.statusFilter.indexOf(2) !== -1 && i.Status === 2) {
          filteredJobs.push(i);
        } else if (this.statusFilter.indexOf(1) !== -1 && i.Status === 1) {
          filteredJobs.push(i);
        } else if (
          this.statusFilter.indexOf(4) !== -1 &&
          i.Allocated &&
          (!i.Status || i.Status < 1)
        ) {
          filteredJobs.push(i);
        } else if (
          this.statusFilter.indexOf(5) !== -1 &&
          !i.Allocated &&
          (!i.Status || i.Status < 1)
        ) {
          filteredJobs.push(i);
        } else {
          continue;
        }
        i.customerName = this.customerNameFromID(i.Customer);
        i.AllocatedEngineer = this.engineerNameFromID(i.Allocated);
      }

      return filteredJobs;
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Job" : "Edit Job";
    },
    suppliers() {
      return this.$store.getters.suppliers;
    },
    currentJobNo() {
      if (this.currentJob) {
        const index = this.jobs.findIndex((job) => {
          return this.currentJob === job.id;
        });
        if (index > -1) {
          return this.jobs[index]["JobNo"];
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    projectsObj() {
      let projectsObj = {};
      for (let project in this.projects) {
        projectsObj[this.projects[project].projectId] = this.projects[project];
      }
      return projectsObj;
    },
    supplierSelectEngineers() {
      let arr = [];
      this.engineers.forEach((engineer) => {
        if (engineer.supplier === this.supplierSelect) {
          arr.push(engineer);
        }
      });
      return arr;
    },
    supplierFilterEngineers() {
      let arr = [];
      this.engineers.forEach((engineer) => {
        if (engineer.supplier === this.supplierFilter || !this.supplierFilter) {
          arr.push(engineer);
        }
      });
      return arr;
    },
    assignToSupplierEngineers() {
      let arr = [];
      this.engineers.forEach((engineer) => {
        if (engineer.supplier === this.assignToSupplier) {
          arr.push(engineer);
        }
      });
      return arr;
    },
    selectedSameProject() {
      let result = true;
      if (this.selected.length === 0) {
        return true;
      }
      let currentProject = this.selected[0]["Project"];
      if (this.selected.length > 1) {
        for (let obj of this.selected) {
          if (currentProject !== obj.Project) {
            result = false;
            break;
          }
        }
      }
      if (result) {
        const index = this.projects.findIndex((project) => {
          return project.projectId === currentProject;
        });
        if (index > -1 && this.projects[index]["Supplier"]) {
          this.assignToSupplier = this.projects[index]["Supplier"];
        } else {
          this.assignToSupplier = null;
        }
      }
      return result;
    },
  },
  watch: {
    "editedItem.finance.type": function (newVal) {
      // If finance type changes, update chargeable accordingly
      this.editedItem.chargeable = newVal === "Chargeable";
    },
    fab(val) {
      this.tooltips = false;
      this.tooltipsDisabled = false;
      val &&
        setTimeout(() => {
          this.tooltips = true;
          this.$nextTick(() => {
            this.tooltipsDisabled = true;
          });
        }, 250);
    },
    vehicleSelect: function (val) {
      if (val === null) {
        val = "";
      }
      if (typeof val === "string") {
        this.editedItem.vehReg = val;
      } else {
        this.editedItem.vehReg = val.VehicleReg;
      }
      const index = this.vehicles.findIndex((vehicle) => {
        return vehicle.VehicleReg === this.editedItem.vehReg;
      });
      if (index > -1) {
        this.editedItem.Vehicle = this.vehicles[index]["key"];
      } else {
        this.editedItem.Vehicle = null;
      }
    },
    selectProducts: function (val) {
      this.editedItem.products = val;
      let productExtras = [];
      let productExtraKeys = [];
      // let keysToDelete = []
      this.editedItem.templateExtras = [];

      const allProducts = this.products;
      const products = this.editedItem.products;
      if (products) {
        products.forEach((v) => {
          // Stores the extras which match the currently selected products in the data model. Can then be queried to make sure we only show the correct extras in the form etc.
          const arrayId = allProducts.findIndex((obj) => {
            return obj.id === v;
          });
          console.log(allProducts[arrayId]);
          if (
            allProducts[arrayId] !== undefined &&
            allProducts[arrayId]["extras"] !== undefined &&
            allProducts[arrayId]["extras"] !== null &&
            allProducts[arrayId]["extras"] !== ""
          ) {
            allProducts[arrayId]["extras"].forEach((extra) => {
              extra["id"] = allProducts[arrayId]["id"];
              productExtras.push(extra);
              productExtraKeys.push(extra.name);
            });
          }

          let templateDetails = [];
          if (allProducts[arrayId] && allProducts[arrayId].devices) {
            for (let template of allProducts[arrayId].devices) {
              let device = this.templates.find((t) => {
                return template === t.id;
              });
              device.deviceDetails = this.devices.find((d) => {
                return (
                  d.type === device.id && d.vehicle === this.editedItem.Vehicle
                );
              });
              templateDetails.push(device);
            }
            this.editedItem.templateExtras.push({
              product: allProducts[arrayId],
              templateDetails: templateDetails,
            });
          }
        });
        // for (let key in this.editedItem.extras) {
        //   // Store names of extras which need to be deleted
        //   if (!productExtraKeys.includes(key)) {
        //     keysToDelete.push(key)
        //   }
        // }
        // keysToDelete.forEach((keyName) => {
        //   delete this.editedItem.extras[keyName]
        // })
        for (let key in productExtraKeys) {
          // IF value of extras hasn't been set, set the value to the default found in db
          let obj = {};
          if (this.editedItem.extras !== undefined) {
            if (!this.editedItem.extras.hasOwnProperty(productExtraKeys[key])) {
              var index = productExtras.findIndex((obj) => {
                return obj.name === productExtraKeys[key];
              });
              if (index === -1) {
                obj[productExtraKeys[key]] = "";
              } else {
                obj[productExtraKeys[key]] = productExtras[key]["default"];
              }
              Object.assign(this.editedItem.extras, obj);
            }
          } else {
            // this.editedItem.extras = {}
            obj[productExtraKeys[key]] = "";
            Object.assign(this.editedItem.extras, obj);
          }
          if (products.indexOf("IGVjrrgemWhH8zki8yBZ") > -1) {
            const vehicleObj = this.vehicles.find((vehicle) => {
              return vehicle.key === this.editedItem.Vehicle;
            });
            this.editedItem.extras["[Tacho Smart] VU Part Number"] =
              vehicleObj && vehicleObj.VUPartNo ? vehicleObj.VUPartNo : "";
          }
        }

        this.editedItem.productExtras = productExtraKeys;
        this.productExtras = productExtras;
        // this.editedItem.extras = this.editedItem.extras
      }
    },
    dialog(val) {
      val || this.close();
    },
    // supplierSelect: function (val) {
    //   this.editedItem.Supplier = val
    //   this.getEngineers(val)
    // },
    // assignToSupplier: function (val) {
    //   this.getEngineers(val)
    // }
  },
  filters: {
    formatDate(val) {
      return val !== undefined && val !== null
        ? moment(val).format("DD/MM/YYYY")
        : null;
    },
    arrayToString(val) {
      let str = "";
      if (val) {
        val.forEach((arrayVal) => {
          str += arrayVal + ", ";
        });
        str = str.substr(0, str.length - 2);
      }
      return str;
    },
    jobStatus(Status, Allocated) {
      if (Status === 3) {
        return "Complete - Cubo Approved";
      } else if (Status === 2) {
        return "Complete";
      } else if (Status === 1) {
        return "Issue";
      } else {
        if (Allocated === "" || Allocated === null || Allocated === undefined) {
          return "Not Started";
        } else {
          return "Awaiting Install";
        }
      }
    },
  },
  methods: {
    fetchData() {
      this.filterPanel = [];
      this.getJobs();
      this.getProjects();
      this.$store.dispatch("fetchDeviceTypes");
      this.$store.dispatch("fetchProductTypes");
      this.$store.dispatch("fetchDevices");
    },
    updateReg(job) {
      const vehIndex = this.vehicles.findIndex((vehicle) => {
        if (job["Vehicle"]) {
          return vehicle.key === job["Vehicle"];
        } else if (job["vehReg"]) {
          return vehicle.VehicleReg === job["vehReg"];
        } else if (job["reg"]) {
          return vehicle.VehicleReg === job["reg"];
        }
      });
      let vehDoc;
      if (vehIndex > -1) {
        vehDoc = this.vehicles[vehIndex]["key"];
        const vehRef = fireStore.collection("Vehicles").doc(vehDoc);
        vehRef.update({ VehicleReg: this.updateRegV });
        this.getVehicles();
      }
    },
    async printSelectedJobs() {
      var mywindow = window.open("", "PRINT");

      mywindow.document.write(
        '<html><head><title>Install Report</title><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/css/materialize.min.css"><style>@media print{#hidePrint{display:none;}}</style>'
      );
      mywindow.document.write("</head><body>");
      mywindow.document.write(
        '<div style="margin-top:10px;" id="hidePrint">Once all images are downloaded click print --> <button class="btn" onclick="window.print();window.close();">Print</button></div>'
      );
      mywindow.document.write(
        '<div style="text-align:right;"><img style="margin-bottom:3px;" width="200" src="../static/img/Cubo-Logo.png" /></div>'
      );

      for (let job of this.selected) {
        let printJob = {};
        let snap = await fireStore
          .collection("Jobs")
          .doc(job.id)
          .collection("CompletedJobs")
          .get();
        for (let doc of snap.docs) {
          printJob = doc.data();
        }
        if (Object.keys(printJob).length < 1) {
          continue;
        }
        if (printJob.vehicle !== undefined) {
          mywindow.document.write("<h4>Vehicle: " + printJob.vehicle + "</h4>");
        } else if (printJob.reg !== undefined) {
          mywindow.document.write("<h4>Vehicle: " + printJob.reg + "</h4>");
        } else {
          mywindow.document.write("<h4>Job: " + printJob.JobNo + "</h4>");
        }
        if (printJob.Date !== undefined) {
          mywindow.document.write(
            "<h4>Date: " + moment(printJob.Date).format("DD/MM/YYYY") + "</h4>"
          );
        }
        for (let item in printJob.template) {
          mywindow.document.write(
            "<h6>" + printJob.template[item].name + "</h6>"
          );
          for (let subitem in printJob.template[item].items) {
            let subitemDetail = printJob.template[item].items[subitem];
            if (subitemDetail.image.length > 0) {
              mywindow.document.write(
                '<img style="margin:3px;" height="250" src="' +
                  subitemDetail.image +
                  '" />'
              );
            } else if (subitemDetail.note.length > 0) {
              mywindow.document.write(
                '<div style="width:200px; display:inline-block;"><span style="margin:3px;">' +
                  subitemDetail.text +
                  ": <strong>" +
                  subitemDetail.note +
                  "</strong></span></div>"
              );
            }
          }
        }
      }
      let images = mywindow.document.getElementsByTagName("img");
      let total = images.length;
      let imageCount = 1;
      for (let image of images) {
        image.onload = () => {
          imageCount++;
          console.log("loaded:" + imageCount);
          if (imageCount === total) {
            mywindow.print();
          }
        };
      }
      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      return true;
    },
    forceUpdate() {
      this.$forceUpdate();
    },
    refreshData() {
      this.getProjects();
      this.getSites();
      this.getVehicles();
      this.getJobs();
    },
    getTemplates() {
      fireStore
        .collection("deviceType")
        .orderBy("Index")
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            let data = doc.data();
            data.id = doc.id;
            this.templates.push(data);
          });
        });
    },
    exportJobs() {
      let exportData =
        "UID\tCustomer\tVehicle\tCreated Date\tScheduled Date\tCompleted Date\tSupplier\tEngineer\tProject\tJob Number\tStatus\tNotes\tCustomer Price\tEngineer Cost\tHardware Cost\tJob Invoiced\n";
      for (let job of this.filteredJobs) {
        exportData +=
          job.id +
          "\t" +
          job.customerName +
          "\t" +
          (job.Vehicle
            ? job.Vehicle
              ? this.vehicleRegFromID(job.Vehicle)
              : job.VehicleReg
            : job.vehReg) +
          "\t" +
          this.$options.filters.formatDate(job.CreatedDate) +
          "\t" +
          this.$options.filters.formatDate(job.Date) +
          "\t" +
          this.$options.filters.formatDate(job.CompletedDate) +
          "\t" +
          this.supplierNameFromID(job.Supplier) +
          "\t" +
          job.AllocatedEngineer +
          "\t" +
          job.Project +
          "\t" +
          job.JobNo +
          "\t" +
          this.$options.filters.jobStatus(job.Status, job.Allocated) +
          "\t" +
          '"' +
          (job.notes || "") +
          '"' +
          "\t" +
          (job.customerPrice || "") +
          "\t" +
          (job.engineerCost || "") +
          "\t" +
          (job.hardwareCost || "") +
          "\t" +
          (job.invoiced || "") +
          "\n";
      }
      navigator.clipboard.writeText(exportData);
      alert("Copied to clipboard");
    },
    processJobs() {
      let jobsObj = require("@/assets/exports/jobs.json");
      let templatesObj = require("@/assets/exports/templates.json");
      let products = [];
      let simNumberFields = [
        "[CS Pro] SIM/Mobile No.",
        "[CSL (DVR)] Sim/Mobile No.",
        "[Tacho Smart] Sim Card Number*",
        "[Track Smart] Sim Card  Number*",
        "[Trailer Smart Calamp] Sim Card Number*",
      ];
      let simProviderFields = [
        "[CS Pro] Sim Provider",
        "[CSL (DVR)] Sim Provider",
        "[Tacho Smart] Sim Provider",
        "[Track Smart] Sim Provider",
        "[Trailer Smart Calamp] Sim Provider",
      ];
      for (let i in jobsObj) {
        for (let n in templatesObj) {
          if (jobsObj[i].templates.indexOf(n) !== -1) {
            let extras = {};
            let vehicle =
              this.vehicles.find((vehicle) => {
                return vehicle.key === jobsObj[i].Vehicle;
              }) !== undefined
                ? this.vehicles.find((vehicle) => {
                    return vehicle.key === jobsObj[i].Vehicle;
                  }).VehicleReg
                : jobsObj[i].vehReg;
            if (jobsObj[i].extras !== undefined) {
              for (let t in templatesObj[n].extras) {
                // console.log(simNumberFields.indexOf(templatesObj[n].extras[t].name))
                if (
                  simNumberFields.indexOf(templatesObj[n].extras[t].name) !== -1
                ) {
                  extras["SIM"] =
                    jobsObj[i].extras[templatesObj[n].extras[t].name];
                }
                if (
                  simProviderFields.indexOf(templatesObj[n].extras[t].name) !==
                  -1
                ) {
                  extras["SIMProvider"] =
                    jobsObj[i].extras[templatesObj[n].extras[t].name];
                }
                extras[templatesObj[n].extras[t].name] =
                  jobsObj[i].extras !== undefined
                    ? jobsObj[i].extras[templatesObj[n].extras[t].name]
                    : null;
              }
            }
            products.push({
              ...{
                vehicle: jobsObj[i].Vehicle || " ",
                vehReg: vehicle,
                product: templatesObj[n].name,
              },
              ...extras,
            });
          }
        }
      }
      for (let title of [...new Set(products.map((x) => x.product))]) {
        console.log(
          products.filter((product) => {
            return product.product === title;
          })
        );
      }
    },
    exportTemplates() {
      let obj = {};
      fireStore
        .collection("Templates")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            obj[doc.id] = doc.data();
          });
          console.log(obj);
        });
    },
    attachCompletedFile(f) {
      let promises = [];
      let downloadUrls = [];
      let fileObj = { Progress: 0, State: 0, files: f };
      const storageRef = storage.ref("CompletedDocs/" + this.currentJob);

      for (const file of fileObj.files) {
        console.log(file);
        promises.push(
          new Promise((resolve, reject) => {
            let uploadTask = storageRef.child(file.name).put(file);
            uploadTask.on(
              "state_changed",
              (snapshot) => {
                // Observe state change events such as progress, pause, and resume
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                var progress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                fileObj["Progress"] = progress;
                this.fileProgress = progress;
              },
              (error) => {
                // Handle unsuccessful uploads
                fileObj["State"] = 4;
                reject(error);
              },
              () => {
                // Handle successful uploads on complete
                fileObj["Progress"] = 100;
                this.fileProgress = 100;
                fileObj["State"] = 3;
                uploadTask.snapshot.ref
                  .getDownloadURL()
                  .then(function (downloadURL) {
                    downloadUrls.push({
                      downloadUrl: downloadURL,
                      name: file.name,
                    });
                    resolve();
                  });
              }
            );
          })
        );
      }

      Promise.all(promises)
        .then((val) => {
          const index = this.jobs.findIndex((job) => {
            return job.id === this.currentJob;
          });
          console.log(index);
          console.log(val);
          if (!this.jobs[index].completedDocs) {
            this.jobs[index].completedDocs = [];
          }
          console.log("CURRRENT JOB -", this.currentJob);
          this.jobs[index].completedDocs.push(...downloadUrls);
          fireStore.collection("Jobs").doc(this.currentJob).update({
            completedDocs: this.jobs[index].completedDocs,
          });
          updateAuditLog(
            "update",
            "projects",
            this.userData,
            this.jobs[index].JobNo,
            this.jobs[index].Project,
            "attached completed document",
            null,
            this.activeCustomer
          );
          this.$forceUpdate();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setJobStates() {
      this.totalJobs = 0;
      this.states = [0, 0, 0, 0, 0];
      this.jobs.forEach((data) => {
        if (data.Status === 3) {
          this.states[4]++;
        } else if (data.Status === 2) {
          this.states[3]++;
        } else if (data.Status === 1) {
          this.states[2]++;
        } else {
          if (
            data.Allocated === "" ||
            data.Allocated === null ||
            data.Allocated === undefined
          ) {
            this.states[0]++;
          } else {
            this.states[1]++;
          }
        }
        this.totalJobs++;
      });
    },
    getJobs() {
      this.tableLoading = true;
      this.jobs = [];
      let statusesToRetrieve = [];
      if (this.statusFilter.indexOf(3) !== -1) {
        statusesToRetrieve.push(3);
      }
      if (this.statusFilter.indexOf(2) !== -1) {
        statusesToRetrieve.push(2);
      }
      if (this.statusFilter.indexOf(1) !== -1) {
        statusesToRetrieve.push(1);
      }
      if (
        this.statusFilter.indexOf(4) !== -1 ||
        this.statusFilter.indexOf(5) !== -1
      ) {
        statusesToRetrieve.push(0);
        statusesToRetrieve.push(-1);
      }
      let query = fireStore
        .collection("Jobs")
        .where("Status", "in", statusesToRetrieve);

      if (this.engineerFilter) {
        console.log("engineer");
        query = query.where("Allocated", "==", this.engineerFilter);
      }

      if (this.supplierFilter) {
        console.log("supplier");
        query = query.where("Supplier", "==", this.supplierFilter);
      }

      if (this.chargeableFilter === "Yes") {
        query = query.where("chargeable", "==", true);
      }

      if (this.dateFilterType === "created") {
        query = query
          .where("CreatedDate", ">", moment(this.startFilter).format("x") * 1)
          .where("CreatedDate", "<", moment(this.endFilter).format("x") * 1);
      }
      if (this.dateFilterType === "scheduled") {
        query = query
          .where("Date", ">", moment(this.startFilter).format("YYYY-MM-DD"))
          .where("Date", "<", moment(this.endFilter).format("YYYY-MM-DD"));
      }
      if (this.dateFilterType === "completed") {
        query = query
          .where(
            "CompletedDate",
            ">",
            moment(this.startFilter).format("YYYY-MM-DD")
          )
          .where(
            "CompletedDate",
            "<",
            moment(this.endFilter).format("YYYY-MM-DD")
          );
      }

      query
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            let data = doc.data();
            data.id = doc.id;
            this.jobs.push(data);
          });
          this.tableLoading = false;
          this.setJobStates();
          this.initialFetch = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProjects() {
      this.projects = [];
      fireStore
        .collection("Projects")
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            let data = doc.data();
            data.id = doc.id;
            this.projects.push(data);
          });
        });
    },
    getSites() {
      this.sites = [];
      fireStore
        .collection("Sites")
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            this.sites.push({
              key: doc.id,
              name: doc.data().Name,
              Customer: doc.data().Customer,
            });
          });
        });
    },
    getEngineers(supplier) {
      this.engineers = [];
      fireStore
        .collection("Users")
        .where("Role", "in", [
          "Engineer",
          "Supplier",
          "Support and Engineer",
          "Admin and Engineer",
        ])
        .orderBy("Name", "asc")
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            this.engineers.push({
              key: doc.data().UID,
              name: doc.data().Name,
              supplier: doc.data().Company,
            });
          });
        });
    },
    getVehicles() {
      this.gettingVehicles = true;
      let vehicles = [];
      fireStore
        .collection("Vehicles")
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            const data = doc.data();
            vehicles.push({
              key: doc.id,
              VehicleReg: data.VehicleReg ? data.VehicleReg : data.friendlyId,
              Customer: data.Customer,
              friendlyId: data.friendlyId,
            });
          });
          this.gettingVehicles = false;
          this.vehicles = vehicles;
        })
        .catch(() => {
          this.gettingVehicles = false;
        });
    },
    viewJob(job) {
      this.currentJob = job;
      this.viewDialog = true;
    },
    issueJob(job) {
      this.currentJob = job;
      this.issueDialog = true;
      this.JobNotes =
        this.jobs.find((job) => {
          return job.id === this.currentJob;
        }).Notes || "";
    },
    issueCurrentJob() {
      this.issueingJob = true;
      const index = this.jobs.findIndex((job) => {
        return job.id === this.currentJob;
      });
      fireStore
        .collection("Jobs")
        .doc(this.currentJob)
        .update({ Notes: this.JobNotes, Status: 1 })
        .then(() => {
          updateAuditLog(
            "update",
            "jobs",
            this.user,
            this.jobs[index].JobNo,
            this.jobs[index].Project,
            "flagged as issue",
            null,
            this.jobs[index].Customer
          );
          let obj = this.jobs[index];
          obj.Status = 1;
          obj.JobNotes = this.JobNotes;
          this.jobs[index] = Object.assign({}, this.jobs[index], obj);
          this.setJobStates(this.activeCustomer);
          this.issueingJob = false;
          this.issueDialog = false;
        });
    },
    approveJob(job) {
      this.currentJob = job;
      const approvalVehicle = this.jobs.find((job) => {
        return job.id === this.currentJob;
      }).Vehicle;
      const approvalVehicleReg = this.vehicles.find((vehicle) => {
        return vehicle.key === approvalVehicle;
      });
      document.getElementById(this.$refs.btnAttachCompletedFile.id).value =
        null;
      this.approvalReg = approvalVehicleReg.VehicleReg.toUpperCase().replace(
        /\s/g,
        ""
      );
      this.approveDialog = true;
    },
    approveCurrentJob() {
      this.approvingJob = true;
      let batch = fireStore.batch();
      let vmJobs = this.jobs;
      const index = this.jobs.findIndex((job) => {
        return job.id === this.currentJob;
      });
      let installedDevices = vmJobs[index].finance || {};
      let completedDate =
        vmJobs[index].CompletedDate || moment().format("YYYY-MM-DD");
      for (let device in installedDevices) {
        if (typeof installedDevices[device] !== "string" && typeof installedDevices[device] !== "number") {
          installedDevices[device].installDate = completedDate;
          installedDevices[device].project = vmJobs[index].Project;
          installedDevices[device].job = vmJobs[index].id;
        }
      }
      let devices = {};
      if (vmJobs[index]["extras"]) {
        devices = vmJobs[index]["extras"];
      }
      let obj = {
        devices: devices,
        installedDevices: installedDevices,
      };
      if (this.approvalReg && this.approvalReg.length > 0) {
        obj.VehicleReg = this.approvalReg;
      }
      const vehIndex = this.vehicles.findIndex((vehicle) => {
        if (vmJobs[index]["Vehicle"]) {
          return vehicle.key === vmJobs[index]["Vehicle"];
        } else if (vmJobs[index]["vehReg"]) {
          return vehicle.VehicleReg === vmJobs[index]["vehReg"];
        } else if (vmJobs[index]["reg"]) {
          return vehicle.VehicleReg === vmJobs[index]["reg"];
        }
      });
      let vehDoc;
      if (vehIndex > -1) {
        vehDoc = this.vehicles[vehIndex]["key"];
        const vehRef = fireStore.collection("Vehicles").doc(vehDoc);
        batch.set(vehRef, obj, { merge: true });
      }
      const jobRef = fireStore.collection("Jobs").doc(this.currentJob);
      let deviceArray = [];
      for (let template of Object.keys(installedDevices)) {
        if (
          this.products.find((p) => {
            return template === p.id;
          }) === undefined
        ) {
          continue;
        }
        let deviceKey = this.products.find((p) => {
          return template === p.id;
        }).devices[0];
        let device = this.templates.find((t) => {
          return deviceKey === t.id;
        });
        if (device) {
          device.deviceDetails = this.devices.find((d) => {
            return d.type === device.id && d.vehicle === vehDoc;
          });
          if (device.deviceDetails) {
            deviceArray.push(device.deviceDetails.id);
            const deviceRef = fireStore
              .collection("Devices")
              .doc(device.deviceDetails.id);
            batch.update(deviceRef, {
              InstallDate: completedDate,
              stockLocation: "Installed",
            });
          }
        }
      }
      batch.update(jobRef, {
        Status: 3,
        CompletedDate: completedDate,
        devicesInstalled: deviceArray,
      });
      batch
        .commit()
        .then(() => {
          let obj = this.jobs[index];
          obj.Status = 3;
          obj.CompletedDate = completedDate;
          this.jobs[index] = Object.assign({}, this.jobs[index], obj);
          this.setJobStates();
          this.approvingJob = false;
          this.approveDialog = false;
          this.$forceUpdate();
          this.getVehicles();
          updateAuditLog(
            "update",
            "jobs",
            this.user,
            this.jobs[index].JobNo,
            this.jobs[index].Project,
            "approved job",
            null,
            this.jobs[index].Customer
          );
          console.log("send email");
          let project =
            this.projects.find(
              (a) => a.projectId === this.jobs[index].Project
            ) || {};
          let customer = this.customerList.find(
            (a) => a.key === this.activeCustomer
          );
          let engineer = this.engineerNameFromID(obj.Allocated);
          let supplier = this.supplierNameFromID(project.Supplier);
          let vehicle = obj.reg;
          sendEmail(
            "invoice@wearecubo.com",
            `Nexus Job Completed-${project.qnq}-${obj.JobNo}-${customer.shortName} ${customer.name}`,
            `-\n
                    QNQ: ${project.qnq}\n
                    Customer: ${customer.name}\n
                    Customer No: ${customer.shortName}\n
                    Project ID: ${obj.Project}\n
                    Job ID: ${obj.JobNo}\n
                    Vehicle Reg: ${vehicle}\n
                    Project Manager: ${project.manager}\n
                    Supplier: ${supplier}\n
                    Engineer: ${engineer}\n
                    BDM: ${customer.BDM}\n
                    Last Actioned: ${this.userData.Name}`
          );
          console.log("email sent");
        })
        .catch(() => {
          this.approvingJob = false;
        });
    },
    editItem(itemId) {
      const itemIndex = this.jobs.findIndex((job) => {
        return job.id === itemId;
      });
      const item = this.jobs[itemIndex];
      console.log(item);
      this.editedIndex = this.jobs.indexOf(item);
      item.VehicleSite = this.filteredJobs.find(
        (j) => j.id === itemId
      ).VehicleSite;
      this.editedItem = Object.assign({}, this.editedItem, item);
      if (!item.newMethod) {
        this.selectProducts = this.editedItem.templates;
      } else {
        this.selectProducts = this.editedItem.products;
      }
      let extras = {};
      for (let extraObjKey in item.extras) {
        if (typeof item.extras[extraObjKey] !== "object") {
          extras[extraObjKey] = item.extras[extraObjKey];
        }
        // for (let extraKey in item.extras[extraObjkey]) {
        //   extras[extraKey] = item.extras[extraObjkey][extraKey]
        // }
      }
      console.log(extras);
      let extObj = {};
      for (let p of this.selectProducts) {
        extObj[p] = {};
      }
      extras = { ...extras, ...extObj };
      this.editedItem["extras"] = Object.assign(
        {},
        this.editedItem["extras"],
        extras
      );
      const index = this.projects.findIndex((project) => {
        return project.projectId === this.editedItem.Project;
      });
      this.supplierSelect =
        index > -1 ? this.projects[index].Supplier || null : null;
      if (this.editedItem.Vehicle) {
        this.vehicleSelect = this.vehicleRegFromID(this.editedItem.Vehicle);
      } else {
        this.vehicleSelect = this.editedItem.vehReg;
      }
      this.editedItem.invoiced = this.editedItem.invoiced
        ? this.editedItem.invoiced.toUpperCase()
        : null;
      this.dialog = true;
    },
    deleteItem(item) {
      const index = this.jobs.findIndex((job) => {
        return job.id === item.id;
      });
      confirm("Are you sure you want to delete this item?") &&
        fireStore
          .collection("Jobs")
          .doc(item.id)
          .delete()
          .then(() => {
            updateAuditLog(
              "delete",
              "jobs",
              this.user,
              this.jobs[index].JobNo,
              this.jobs[index].Project,
              "deleted job",
              null,
              this.jobs[index].Customer
            );
            this.jobs.splice(index, 1);
            this.setJobStates();
          });
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.productExtras = [];
        this.selectProducts = [];
        this.vehicleSelect = "";
        this.supplierSelect = "";
      }, 300);
    },
    save() {
      this.savingSaveJob = true;
      let sortedTemplates = [];
      let deviceArray = [];
      let jobLookupIds = [];
      this.templates.forEach((template) => {
        for (let t of this.editedItem.templateExtras) {
          if (t.product.devices.includes(template.id)) {
            sortedTemplates.push(template.id);
          }
          for (let d of t.templateDetails) {
            if (d.deviceDetails) {
              deviceArray.push({
                product: t.product.id,
                device: d.deviceDetails.id,
              });
              if (d.deviceDetails.IMEI) {
                jobLookupIds.push({
                  IMEI: d.deviceDetails.IMEI,
                  template: d.deviceDetails.type,
                });
              }
              if (d.deviceDetails["DVR ID Number"]) {
                jobLookupIds.push({
                  DVR: d.deviceDetails["DVR ID Number"],
                  template: d.deviceDetails.type,
                });
              }
            }
          }
        }
      });
      if (
        sortedTemplates.indexOf("preCheck") === -1 &&
        sortedTemplates.indexOf("5oJKuVseN0PkmvZeDl0J") === -1
      ) {
        sortedTemplates.unshift("preCheck");
      }
      if (
        sortedTemplates.indexOf("Je2nQqSdazW25XWSGkt3") === -1 &&
        sortedTemplates.indexOf("5oJKuVseN0PkmvZeDl0J") === -1
      ) {
        sortedTemplates.push("Je2nQqSdazW25XWSGkt3");
      }
      jobLookupIds = jobLookupIds.filter((obj, pos, arr) => {
        return (
          arr.map((mapObj) => mapObj["template"]).indexOf(obj["template"]) ===
          pos
        );
      });
      this.editedItem.templates = sortedTemplates.filter(
        (item, pos) => sortedTemplates.indexOf(item) === pos
      );
      this.editedItem.newMethod = true;
      this.editedItem.VehicleSite = this.editedItem.VehicleSite || null;
      this.editedItem.Supplier = this.supplierSelect;
      let obj = this.editedItem;
      obj.jobLookupIds = jobLookupIds;
      if (obj.extras) {
        for (let extra in obj.extras) {
          if (!obj.extras[extra]) {
            obj.extras[extra] = "";
          }
        }
      }
      delete obj["productExtras"];
      delete obj["templateExtras"];
      if (this.editedIndex > -1) {
        fireStore
          .collection("Jobs")
          .doc(this.editedItem.id)
          .set(obj, { merge: true })
          .then(() => {
            updateAuditLog(
              "update",
              "jobs",
              this.user,
              obj.JobNo,
              obj.Project,
              "edited job",
              obj,
              obj.Customer
            );
            Object.assign(this.jobs[this.editedIndex], obj);
            this.getJobs();
            this.savingSaveJob = false;
            for (let device of deviceArray) {
              fireStore.collection("Devices").doc(device.device).set(
                {
                  customer: this.editedItem.Customer,
                  vehicle: this.editedItem.Vehicle,
                  product: device.product,
                },
                { merge: true }
              );
            }
            this.close();
          })
          .catch((error) => {
            this.saveJobFailed = true;
            this.savingSaveJob = false;
            console.log(error);
          });
      } else {
        const customerIndex = this.customerList.findIndex((customerListObj) => {
          return customerListObj.key === obj.Customer;
        });
        const shortName = this.customerList[customerIndex]["shortName"];
        fireStore
          .collection("Jobs")
          .where("Customer", "==", obj.Customer)
          .get()
          .then((docRef) => {
            let jobNumbers = [];
            docRef.forEach((doc) => {
              let JobNo = doc.data().JobNo;
              if (JobNo && JobNo.indexOf(shortName) > -1) {
                // This check is needed in case the short name has been changed. We only want to increment on job numbers with the new short name.
                JobNo = JobNo.replace(/\D/g, "");
                jobNumbers.push(JobNo);
              }
            });
            jobNumbers = jobNumbers.sort();
            jobNumbers = jobNumbers.reverse();
            if (jobNumbers.length === 0) {
              jobNumbers.push(0);
            }
            this.editedItem.JobNo =
              shortName + this.zeroFill(parseInt(jobNumbers[0]) + 1, 4);
            obj.CreatedDate = Date.now();
            fireStore
              .collection("Jobs")
              .add(obj)
              .then((docRef) => {
                updateAuditLog(
                  "added",
                  "jobs",
                  this.user,
                  obj.JobNo,
                  obj.Project,
                  "added job",
                  obj,
                  obj.Customer
                );
                this.editedItem.id = docRef.id;
                obj.id = docRef.id;
                this.jobs.push(obj);
                for (let device of deviceArray) {
                  fireStore.collection("Devices").doc(device.device).set(
                    {
                      customer: this.editedItem.Customer,
                      vehicle: this.editedItem.Vehicle,
                      product: device.product,
                    },
                    { merge: true }
                  );
                }
                this.getJobs();
                this.close();
                this.savingSaveJob = false;
              })
              .catch((error) => {
                console.log(error);
                this.saveJobFailed = true;
                this.savingSaveJob = false;
              });
          })
          .catch((error) => {
            this.savingSaveJob = false;
            this.saveJobFailed = true;
            console.log(error);
          });
      }
    },
    addAdditionalField() {
      if (this.editedItem.additionalFields === undefined) {
        this.editedItem.additionalFields = [];
      }
      this.editedItem.additionalFields.push({ fieldName: "", fieldValue: "" });
    },
    addJobsToProject() {
      this.savingAddJobsToProject = true;
      const project = this.assignToProject;
      const supplier =
        this.projectsObj[project].Supplier !== undefined
          ? this.projectsObj[project].Supplier
          : null;
      let batch = fireStore.batch();
      let vmJobs = this.jobs;
      this.selected.forEach((job, index) => {
        const ref = fireStore.collection("Jobs").doc(job.id);
        batch.update(ref, { Project: project, Supplier: supplier });
        updateAuditLog(
          "update",
          "jobs",
          this.user,
          job.JobNo,
          job.Project,
          "changed jobs project",
          null,
          job.Customer
        );
      });
      batch
        .commit()
        .then(() => {
          this.selected.forEach((job, index) => {
            const vmIndex = vmJobs.findIndex((vmJob) => {
              return vmJob.id === job.id;
            });
            vmJobs[vmIndex]["Project"] = project;
            vmJobs[vmIndex]["Supplier"] = supplier;
          });
          this.jobs = vmJobs;
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          this.assignToProject = null;
          this.savingAddJobsToProject = false;
          this.addToProjectDialog = false;
        });
    },
    assignJobsToEngineer() {
      this.savingAssignJobsToEngineer = true;
      const engineer = this.assignToEngineer;
      let batch = fireStore.batch();
      let vmJobs = this.jobs;
      this.selected.forEach((job, index) => {
        const ref = fireStore.collection("Jobs").doc(job.id);
        batch.update(ref, { Allocated: engineer });
        updateAuditLog(
          "update",
          "jobs",
          this.user,
          job.JobNo,
          job.Project,
          "changed engineer on job",
          { Allocated: engineer },
          job.Customer
        );
      });
      batch
        .commit()
        .then(() => {
          this.selected.forEach((job, index) => {
            const vmIndex = vmJobs.findIndex((vmJob) => {
              return vmJob.id === job.id;
            });
            vmJobs[vmIndex]["Allocated"] = engineer;
          });
          this.jobs = vmJobs;
          this.assignToProject = null;
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          this.savingAssignJobsToEngineer = false;
          this.assignToSupplier = "";
          this.assignToEngineer = "";
          this.assignToEngineerDialog = false;
        });
    },
    deleteMultiJobs() {
      this.deletingJobs = true;
      let batch = fireStore.batch();
      let vmJobs = this.jobs;
      this.selected.forEach((job, index) => {
        const ref = fireStore.collection("Jobs").doc(job.id);
        batch.delete(ref);
        updateAuditLog(
          "delete",
          "jobs",
          this.user,
          job.JobNo,
          job.Project,
          "deleted jobs",
          null,
          job.Customer
        );
      });
      batch
        .commit()
        .then(() => {
          this.selected.forEach((job, index) => {
            const vmIndex = vmJobs.findIndex((vmJob) => {
              return vmJob.id === job.id;
            });
            vmJobs.splice(vmIndex, 1);
          });
          this.jobs = vmJobs;
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          this.setJobStates();
          this.deletingJobs = false;
          this.deleteJobsDialog = false;
          this.selected = [];
        });
    },
    createDuplicateProject() {
      let projectTemplate = {};
      for (let project in this.projects) {
        if (this.projects[project].projectId === this.duplicateProjectSource) {
          projectTemplate = JSON.parse(JSON.stringify(this.projects[project]));
          break;
        }
      }
      projectTemplate.Supplier = this.duplicateProjectSupplier;
      let hasID = false;
      let i = 0;
      while (hasID === false) {
        i++;
        if (
          this.projectsObj[projectTemplate.projectId + "-" + i] === undefined
        ) {
          projectTemplate.projectId = projectTemplate.projectId + "-" + i;
          hasID = true;
        }
      }
      fireStore
        .collection("Projects")
        .add(projectTemplate)
        .then((docRef) => {
          this.getProjects();
          this.assignToProject = projectTemplate.projectId;
          this.createNewProject = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    approveMultiJobs() {
      this.approveMultiJobs = true;
      let batch = fireStore.batch();
      let vmJobs = this.jobs;
      this.selected.forEach((job, index) => {
        const vmIndex = vmJobs.findIndex((vmJob) => {
          return vmJob.id === job.id;
        });
        let completedDate =
          vmJobs[vmIndex].CompletedDate || moment().format("YYYY-MM-DD");
        let installedDevices = vmJobs[vmIndex].finance || {};
        for (let device in installedDevices) {
          if (typeof installedDevices[device] !== "string" && typeof installedDevices[device] !== "number") {
            installedDevices[device].installDate = completedDate;
            installedDevices[device].project = vmJobs[vmIndex].Project;
            installedDevices[device].job = vmJobs[index].id;
          }
        }
        // let installedDevices = {}
        // vmJobs[vmIndex]['templates'].forEach(template => {
        //   if (template !== 'preCheck') {
        //     installedDevices[template] = true
        //   }
        // })
        let obj = {
          devices: vmJobs[vmIndex]["extras"],
          installedDevices: installedDevices,
        };

        const vehIndex = this.vehicles.findIndex((vehicle) => {
          return vehicle.VehicleReg === job.vehReg;
        });
        let vehDoc;
        if (vehIndex > -1) {
          vehDoc = this.vehicles[vehIndex]["key"];
          const vehRef = fireStore.collection("Vehicles").doc(vehDoc);
          batch.update(vehRef, obj);
        }
        let deviceArray = [];
        for (let template of Object.keys(installedDevices)) {
          if (
            this.products.find((p) => {
              return template === p.id;
            }) === undefined
          ) {
            continue;
          }
          let deviceKey = this.products.find((p) => {
            return template === p.id;
          }).devices[0];
          let device = this.templates.find((t) => {
            return deviceKey === t.id;
          });
          if (device) {
            device.deviceDetails = this.devices.find((d) => {
              return d.type === device.id && d.vehicle === vehDoc;
            });
            if (device.deviceDetails) {
              deviceArray.push(device.deviceDetails.id);
              const deviceRef = fireStore
                .collection("Devices")
                .doc(device.deviceDetails.id);
              batch.update(deviceRef, {
                InstallDate: completedDate,
                stockLocation: "Installed",
              });
            }
          }
        }
        const jobRef = fireStore.collection("Jobs").doc(job.id);
        batch.update(jobRef, {
          Status: 3,
          CompletedDate: completedDate,
          devicesInstalled: deviceArray,
        });
        updateAuditLog(
          "update",
          "jobs",
          this.user,
          job.JobNo,
          job.Project,
          "approved jobs",
          null,
          job.Customer
        );
        console.log("send email");
        let project =
          this.projects.find((a) => a.projectId === job.Project) || {};
        let customer = this.customerList.find(
          (a) => a.key === this.activeCustomer
        );
        let engineer = this.engineerNameFromID(job.Allocated);
        let supplier = this.supplierNameFromID(project.Supplier);
        let vehicle = job.reg;
        sendEmail(
          "invoice@wearecubo.com",
          `Nexus Job Completed-${project.qnq}-${job.JobNo}-${customer.shortName} ${customer.name}`,
          `-\n
                    QNQ: ${project.qnq}\n
                    Customer: ${customer.name}\n
                    Customer No: ${customer.shortName}\n
                    Project ID: ${job.Project}\n
                    Job ID: ${job.JobNo}\n
                    Vehicle Reg: ${vehicle}\n
                    Project Manager: ${project.manager}\n
                    Supplier: ${supplier}\n
                    Engineer: ${engineer}\n
                    BDM: ${customer.BDM}\n
                    Last Actioned: ${this.userData.Name}`
        );
        console.log("email sent");
      });
      batch
        .commit()
        .then(() => {
          this.selected.forEach((job) => {
            const vmIndex = vmJobs.findIndex((vmJob) => {
              return vmJob.id === job.id;
            });
            vmJobs[vmIndex]["Status"] = 3;
            if (!vmJobs[vmIndex]["CompletedDate"]) {
              vmJobs[vmIndex]["CompletedDate"] = moment().format("YYYY-MM-DD");
            }
          });
          this.jobs = vmJobs;
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          this.setJobStates();
          this.approveMultiJobs = false;
          this.approveJobsDialog = false;
          this.selected = [];
        });
    },
    setJobSupplier() {
      if (this.editedItem.Project) {
        const index = this.projects.findIndex((project) => {
          return project.projectId === this.editedItem.Project;
        });
        if (index > -1 && this.projects[index]["Supplier"]) {
          this.supplierSelect = this.projects[index]["Supplier"];
        } else {
          this.supplierSelect = null;
          this.editedItem.Allocated = "";
        }
      } else {
        this.supplierSelect = null;
        this.editedItem.Allocated = "";
      }
    },
    zeroFill(number, width) {
      width -= number.toString().length;
      if (width > 0) {
        return (
          new Array(width + (/\./.test(number) ? 2 : 1)).join("0") + number
        );
      }
      return number;
    },
    vehicleRegFromID(id) {
      const index = this.vehicles.findIndex((vehicle) => {
        return vehicle.key === id;
      });
      if (index > -1) {
        if (
          this.vehicles[index]["VehicleReg"] &&
          this.vehicles[index]["VehicleReg"].length > 0
        ) {
          return this.vehicles[index]["VehicleReg"];
        } else if (this.vehicles[index]["friendlyId"]) {
          return this.vehicles[index]["friendlyId"];
        } else {
          return id;
        }
      } else {
        return id;
      }
    },
    engineerNameFromID(id) {
      const index = this.engineers.findIndex((engineer) => {
        return engineer.key === id;
      });
      if (index > -1) {
        return this.engineers[index]["name"];
      } else {
        return "";
      }
    },
    supplierNameFromID(id) {
      const index = this.suppliers.findIndex((supplier) => {
        return supplier.key === id;
      });
      return index > -1 ? this.suppliers[index].name : null;
    },
    customerNameFromID(id) {
      const index = this.customerList.findIndex((customer) => {
        return customer.key === id;
      });
      return index > -1 ? this.customerList[index].name : null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Jobs.vue?4ceb52b4